import { render } from "./docsAndCertifications.vue?vue&type=template&id=59694322&ts=true"
import script from "./docsAndCertifications.vue?vue&type=script&lang=ts"
export * from "./docsAndCertifications.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__